module.exports = __webpack_public_path__ + "static/teleco_8-0678ecd037d8dfea9bcfe3bac987c232.jpg";